export default __webpack_public_path__ + "static/media/http.45c9cde2.svg";